import React from 'react'

export default function CompletionPanel({ totalScore, onComplete }) {
  return (
    <div className="vocabulary-completion">
      <div className="completion-icon">🎉</div>
      <h3 className="completion-title">Chúc mừng!</h3>
      <p>
        Bạn đã hoàn thành bài học từ vựng!<br />
        Tổng điểm: <span className="completion-score">{totalScore}</span>
      </p>
      <button
        type="button"
        className="btn btn-success btn-lg"
        onClick={onComplete}
        data-testid="complete-button"
      >
        ✓ Hoàn thành
      </button>
    </div>
  )
}
